export class InternalServerError extends Error {
      constructor() {
            super();
            this.message = "There is some error at SignCatch.";
            this.name = "Internal Server Error";
      }
}

export class UnauthorizedError extends Error {
      constructor(message: string) {
            super(message);
            this.message = message;
            this.name = "Unauthorized Request";
      }
}

export class NetworkError extends Error {
      constructor() {
            super();
            this.message = "Could not connect to Server.";
            this.name = "Network Error";
      }
}

export class DatabaseError extends Error {
      code;
      constructor(data: any) {
            super();
            this.message = data.message;
            this.code = data.code;
            this.name = "Database Error";
      }
}